import { Button, IconButton, alpha } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { FC } from 'react';
import { NavigationConfig } from './useNavigation';

interface NavigationButtonProps {
  isDrawerOpen: boolean;
  buttonConfig: NavigationConfig['button'] | undefined;
}

export const NavigationButton: FC<NavigationButtonProps> = ({ isDrawerOpen, buttonConfig }) => {
  if (!buttonConfig) {
    return null;
  }

  const handleNavigation = () => {
    window.location.assign(buttonConfig.to);
  };

  if (isDrawerOpen) {
    return (
      <Button
        key={buttonConfig.key}
        onClick={handleNavigation}
        aria-label={buttonConfig.label}
        startIcon={<ChevronLeftIcon />}
        variant="outlined"
        className="w-full"
        sx={(theme) => ({
          textTransform: 'none',
          fontWeight: 600,
          color: 'text.secondary',
          borderColor: 'divider',
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow']),
          '& .MuiButton-startIcon': {
            transition: theme.transitions.create('transform'),
          },
          '&:hover': {
            color: 'text.primary',
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
            boxShadow: `0 0 12px ${alpha(theme.palette.primary.main, 0.35)}`,
            '& .MuiButton-startIcon': {
              transform: 'translateX(-3px)',
            },
          },
        })}
      >
        {buttonConfig.label}
      </Button>
    );
  }

  return (
    <IconButton
      onClick={handleNavigation}
      aria-label={buttonConfig.label}
      sx={(theme) => ({
        width: 40,
        height: 40,
        color: 'text.secondary',
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow']),
        '&:hover': {
          color: 'text.primary',
          borderColor: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.16),
          boxShadow: `0 0 12px ${alpha(theme.palette.primary.main, 0.35)}`,
        },
      })}
    >
      <ChevronLeftIcon />
    </IconButton>
  );
};
